var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-t-xs-20 p-b-xs-20" },
    [
      !_vm.loading
        ? _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "m-b-xs-20" }, [
                  _c(
                    "div",
                    { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel__header ak-panel__header--small",
                        },
                        [
                          _c("h2", { staticClass: "ak-form__title" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "Bepaal verzendkosten en afhaalpunten voor "
                                  )
                                ) +
                                " " +
                                _vm._s(_vm.product.title) +
                                "\n                            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel__body ak-panel__body--small reading",
                        },
                        [
                          _vm.prices
                            ? _vm._l(_vm.prices, function (price) {
                                return _c("ak-price", {
                                  key: price.id,
                                  attrs: {
                                    id: "price-pickup-" + price.id,
                                    title: price.label,
                                    value: price.priceRaw,
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onInputPrice($event, price)
                                    },
                                  },
                                })
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasPickupType
                            ? _c(
                                "div",
                                { staticClass: "ak-form__group" },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "ak-form__label" },
                                    [_vm._v("Locaties")]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.organisations,
                                    function (organisation) {
                                      return _c(
                                        "div",
                                        { key: organisation.id },
                                        [
                                          _c(
                                            "ak-form-decorator",
                                            {
                                              attrs: {
                                                id: organisation.id.toString(),
                                                value: organisation.checked,
                                              },
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "ak-form__checkbox",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          organisation.checked,
                                                        expression:
                                                          "organisation.checked",
                                                      },
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked:
                                                        organisation.checked,
                                                      checked: Array.isArray(
                                                        organisation.checked
                                                      )
                                                        ? _vm._i(
                                                            organisation.checked,
                                                            null
                                                          ) > -1
                                                        : organisation.checked,
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$a =
                                                              organisation.checked,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = null,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                _vm.$set(
                                                                  organisation,
                                                                  "checked",
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ])
                                                                )
                                                            } else {
                                                              $$i > -1 &&
                                                                _vm.$set(
                                                                  organisation,
                                                                  "checked",
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    )
                                                                )
                                                            }
                                                          } else {
                                                            _vm.$set(
                                                              organisation,
                                                              "checked",
                                                              $$c
                                                            )
                                                          }
                                                        },
                                                        function ($event) {
                                                          return _vm.onChangeOrganisation(
                                                            organisation
                                                          )
                                                        },
                                                      ],
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass:
                                                      "ak-form__checkmark ak-form__checkmark--checkbox",
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        organisation.label
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          organisation.locations
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "25px",
                                                  },
                                                },
                                                _vm._l(
                                                  organisation.locations,
                                                  function (location) {
                                                    return _c(
                                                      "div",
                                                      { key: location.id },
                                                      [
                                                        _c(
                                                          "ak-form-decorator",
                                                          {
                                                            attrs: {
                                                              id:
                                                                "org-" +
                                                                location.id,
                                                              value:
                                                                location.checked,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "ak-form__checkbox",
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        location.checked,
                                                                      expression:
                                                                        "location.checked",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "checkbox",
                                                                  },
                                                                  domProps: {
                                                                    checked:
                                                                      location.checked,
                                                                    checked:
                                                                      Array.isArray(
                                                                        location.checked
                                                                      )
                                                                        ? _vm._i(
                                                                            location.checked,
                                                                            null
                                                                          ) > -1
                                                                        : location.checked,
                                                                  },
                                                                  on: {
                                                                    change: [
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            location.checked,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c =
                                                                            $$el.checked
                                                                              ? true
                                                                              : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              null,
                                                                            $$i =
                                                                              _vm._i(
                                                                                $$a,
                                                                                $$v
                                                                              )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                location,
                                                                                "checked",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v,
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                location,
                                                                                "checked",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            location,
                                                                            "checked",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      },
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.onChangeLocation(
                                                                          organisation,
                                                                          location
                                                                        )
                                                                      },
                                                                    ],
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "ak-form__checkmark ak-form__checkmark--checkbox",
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        location.label
                                                                      ),
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "ak-button",
                            {
                              attrs: { colorMode: "primary" },
                              on: { click: _vm.submit },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("Verzenden")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "ak-button",
                            {
                              attrs: {
                                colorMode: "ghost",
                                enableConfirm: true,
                                confirmTitle: _vm.$t("Ben je zeker?"),
                                confirmText: _vm.$t(
                                  "Ben je zeker dat je wil annuleren?"
                                ),
                              },
                              on: { click: _vm.cancel },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("Annuleren")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ak-loader", { attrs: { size: "large", loading: _vm.loading } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }